import { CharacterClass, TalentTree } from '../../shared/CharacterTypes';
import { WARRIOR_TALENTS, HUNTER_TALENTS, ROGUE_TALENTS } from './talents/martialTalents';
import { MAGE_TALENTS, PRIEST_TALENTS, WARLOCK_TALENTS } from './talents/casterTalents';
import { PALADIN_TALENTS, DRUID_TALENTS, SHAMAN_TALENTS } from './talents/hybridTalents';

// Talent Tree Configurations
export const TALENT_TREES: Record<CharacterClass, TalentTree> = {
  [CharacterClass.WARRIOR]: WARRIOR_TALENTS,
  [CharacterClass.MAGE]: MAGE_TALENTS,
  [CharacterClass.HUNTER]: HUNTER_TALENTS,
  [CharacterClass.PALADIN]: PALADIN_TALENTS,
  [CharacterClass.DRUID]: DRUID_TALENTS,
  [CharacterClass.DEV]: {},
  [CharacterClass.ROGUE]: ROGUE_TALENTS,
  [CharacterClass.SHAMAN]: SHAMAN_TALENTS,
  [CharacterClass.PRIEST]: PRIEST_TALENTS,
  [CharacterClass.WARLOCK]: WARLOCK_TALENTS,
};
